var FilterTypes;
(function (FilterTypes) {
    FilterTypes["GenericMultiSelect"] = "GenericMultiSelect";
    FilterTypes["SearchSelect"] = "searchSelect";
    FilterTypes["TreeMultiSelect"] = "treeMultiSelect";
})(FilterTypes || (FilterTypes = {}));
export default FilterTypes;
